import { Box, Table as MuiTable } from "@mui/material";
import LoadingScreen from "components/loading/LoadingScreen";
import { useMemo } from "react";

import TableBody from "./TableBody";
import TableHeader from "./TableHeader";
import TablePagination from "./TablePagination";
import TableToolbar from "./TableToolbar";

const Table = ({
  columns,
  data,
  loading,
  actionColumn, // cột hành động: onEdit, onDelete
  toolbar, // gồm title, onCreate,
  maxHeight,
  pagination, // page, pageSize default 20, onChange
  showBorder, // hiển thị border cho tablecell
  showHoverRow, // hiển thị highlight row khi hover
}) => {
  const flatColumns = useMemo(
    () => columns?.map((col) => col.children || col).flat(),
    [columns]
  );

  return (
    <Box>
      {toolbar && <TableToolbar toolbar={toolbar} />}
      <Box sx={{ overflow: "auto", maxHeight }}>
        <MuiTable size="small">
          <TableHeader
            columns={columns}
            actionColumn={actionColumn}
            showBorder={showBorder}
          />
          <TableBody
            columns={flatColumns}
            data={data}
            actionColumn={actionColumn}
            showBorder={showBorder}
            showHoverRow={showHoverRow}
          />
        </MuiTable>
        <LoadingScreen loading={loading} />
      </Box>
      {pagination && <TablePagination pagination={pagination} />}
    </Box>
  );
};

export default Table;
